<template>
  <div>
    <div class="chart_example" :id="id"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["id", "catetoryData"],
  mounted() {
    let $this = this;
    let id = this.id;
    let catetoryData = this.catetoryData;
    let myChart = $this.$echarts.init(document.getElementById(id));
    let seriesData = [];
    let legendData = [
      "测序",
      "云平台",
      "审核",
      "报告",
      "全流程",
      "最大时长",
      "最小时长",
    ];
    let legendColor = [
      "#FFC344",
      "#79C489",
      "#FD6E51",
      "#3E7FFF",
      "#424A54",
      "#AA8E69",
      "#7DB1B1",
    ];
    let legendName = [
      "seqAvgTime",
      "saasAvgTime",
      "verifyAvgTime",
      "reportAvgTime",
      "avgTime",
      "maxTime",
      "minTime",
    ];
    let testData1 = [];
    legendName.forEach(function (item, i) {
      let itemVal = [];
      catetoryData.seriesData.forEach(function (itemName, j) {
        itemVal.push(itemName["" + item + ""]);
      });
      testData1.push(itemVal);
    });
    if (legendData.length > 0) {
      legendData.forEach(function (item, i) {
        let sData = {
          name: item,
          type: "bar",
          barMaxWidth: 15,
          zlevel: 11,
          data: testData1[i],
          itemStyle: {
            normal: {
              barBorderRadius: [0, 0, 0, 0],
              color: new $this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: legendColor[i],
                },
                {
                  offset: 1,
                  color: legendColor[i],
                },
              ]),
            },
          },
        };
        if (
          item == "测序" ||
          item == "云平台" ||
          item == "审核" ||
          item == "报告"
        ) {
          sData.stack = "time1";
        } else {
          sData.barGap = "50%";
        }
        seriesData.push(sData);
      });
    }
    let option = {
      title: [
        {
          text: "处理时长 | 就诊流程",
          left: "1%",
          top: "1%",
          textStyle: {
            fontSize: "16px",
            fontFamily: "PingFang SC",
            fontWeight: 400,
            color: "rgba(51,51,51,1)",
          },
        },
      ],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
        },
      },
      legend: {
        data: legendData,
        left: "15%",
        top: "1%",
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        top: "15%",
        containLabel: true,
      },
      xAxis: [
        {
          type: "category",
          data: catetoryData.yAxisData,
        },
      ],
      yAxis: [
        {
          type: "value",
        },
      ],
      series: seriesData,
    };
    myChart.setOption(option, true);

    //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
    window.addEventListener("resize", function () {
      myChart.resize();
    });
  },
  methods: {},
  watch: {},
  created() {},
};
</script>
<style scoped>
h2 {
  text-align: center;
  padding: 30px;
  font-size: 18px;
}

.chart_example {
  height: 546px;
  padding: 20px;
  background: #fff;
  /* border: 1px solid red; */
  margin: 0 auto;
}
</style>